import { render, staticRenderFns } from "./promotion-form.vue?vue&type=template&id=011faf9c&scoped=true&"
import script from "./promotion-form.vue?vue&type=script&lang=js&"
export * from "./promotion-form.vue?vue&type=script&lang=js&"
import style0 from "./promotion-form.vue?vue&type=style&index=0&id=011faf9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011faf9c",
  null
  
)

/* custom blocks */
import block0 from "./promotion-form.vue?vue&type=custom&index=0&blockType=app-loading&%3Aoverlay=overlay"
if (typeof block0 === 'function') block0(component)

export default component.exports